<div class="relative container mx-auto mt-12 space-y-8">
  <div class="flex flex-col rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <h2 class="pb-4 text-3xl text-zinc-900 dark:text-zinc-200">
      {{ status }} Ethnic Group Ministry
    </h2>
    <p>
      {{ instructions }}
    </p>
  </div>

  <!-- Add ethnic group button -->
  <div>
    <button *ngIf="addState"
      class="flex cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-green-100 outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none"
      (click)="change()">
      <span class="pr-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
          <path
            d="M10 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM1.615 16.428a1.224 1.224 0 0 1-.569-1.175 6.002 6.002 0 0 1 11.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 0 1 7 18a9.953 9.953 0 0 1-5.385-1.572ZM16.25 5.75a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Z" />
        </svg>
      </span>
      Add Ethnic Group
    </button>
  </div>

  <!-- Add ethnic group form -->
  <form *ngIf="!addState" [formGroup]="ethnicGroupForm" (ngSubmit)="onSubmit()"
    class="grid grid-cols-1 md:grid-cols-2 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10">
    <!-- Universal Questions -->
    <div class="flex flex-col gap-8">
      <div class="relative grid grid-cols-1 md:grid-cols-2 items-center gap-2 md:gap-0">
        <label class="pr-0 md:pr-8" for="Name">Name of Ethnic Group?</label>
        <input
          class="self-start rounded-lg border px-3 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          type="text" formControlName="Name" title="Name" placeholder="Group Name" />
        <span *ngIf="!ethnicGroupForm.get('Name')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          Please enter a name of an ethnic group
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-2 items-center gap-2 md:gap-0">
        <label class="pr-0 md:pr-8" for="Language">What language do they speak?</label>
        <input
          class="self-start rounded-lg border px-3 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          type="text" formControlName="Language" title="Language spoken" placeholder="Enter language" />
        <!--  -->
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-2 items-center gap-2 md:gap-0">
        <label class="pr-0 md:pr-8" for="Location">In what location?</label>
        <input
          class="self-start rounded-lg border px-3 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          type="text" formControlName="Location" title="Location" placeholder="Enter location" />
        <!-- -->
      </div>
    </div>

    <!-- "Future" Questions -->
    <div class="flex flex-col gap-8 pl-0 md:pl-12 mt-8 md:mt-0">
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Future'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="Workers">
          How many workers do you anticipate for this?
        </label>
        <input
          class="col-span-1 w-full rounded-lg border px-2 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat formControlName="Workers" title="Number of workers" />
        <span *ngIf="!ethnicGroupForm.get('Workers')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('Workers')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('Workers')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Future'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="AmountPerWorker">How much will it cost you in US$
          (each month) per
          worker?</label>
        <input
          class="col-span-1 w-full rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat [allowDecimals]="true" formControlName="AmountPerWorker"
          title="Monthly cost per worker in USD" />
        <span *ngIf="!ethnicGroupForm.get('AmountPerWorker')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('AmountPerWorker')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('AmountPerWorker')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>

      <!-- "Current" Questions -->
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Current'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="Workers">How many total workers are working among this
          group?</label>
        <input
          class="col-span-1 w-full rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat formControlName="Workers" title="Total workers" />
        <span *ngIf="!ethnicGroupForm.get('Workers')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('Workers')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('Workers')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Current'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="WorkersBenefitted">How many workers benefit from CAM
          support?</label>
        <input
          class="col-span-1 w-full rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat formControlName="WorkersBenefitted" title="Workers benefiting from CAM support" />
        <span *ngIf="!ethnicGroupForm.get('WorkersBenefitted')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('WorkersBenefitted')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('WorkersBenefitted')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Current'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="Churches">How many churches?</label>
        <input
          class="col-span-1 w-full rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat formControlName="Churches" title="Number of churches" />
        <span *ngIf="!ethnicGroupForm.get('Churches')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('Churches')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('Churches')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0" *ngIf="status == 'Current'">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="Believers">How many believers?</label>
        <input
          class="col-span-1 w-full rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          appNumberFormat formControlName="Believers" title="Number of believers" />
        <span *ngIf="!ethnicGroupForm.get('Believers')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('Believers')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('Believers')?.errors?.['maxDigits']">
            Please enter a number
          </span>
        </span>
      </div>
      <div class="relative grid grid-cols-1 md:grid-cols-6 items-center gap-2 md:gap-0">
        <label class="col-span-1 md:col-span-5 pr-0 md:pr-8" for="Year">{{
          status == "Current"
          ? "What year did your ministrys work for this ethnic group begin?"
          : " What year do you expect your ministry's work for this ethnic group to begin?"
          }}</label>
        <input
          class="self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
          type="text" formControlName="Year" title="Year of ministry work" maxlength="4" pattern="[0-9]*" />
        <span *ngIf="!ethnicGroupForm.get('Year')?.valid && submitted"
          class="relative block md:absolute md:-top-5 md:right-0 text-sm text-cam-red">
          <span *ngIf="ethnicGroupForm.get('Year')?.errors?.['maxDigits']">
            Maximum 10 digits allowed
          </span>
          <span *ngIf="!ethnicGroupForm.get('Year')?.errors?.['maxDigits']">
            Please enter a year
          </span>
        </span>
      </div>
    </div>

    <!-- Buttons -->
    <div class="col-span-1 md:col-span-2 mt-6 flex justify-center gap-8">
      <button type="submit"
        class="cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none">
        Save
      </button>
      <button type="button"
        class="cursor-pointer justify-center rounded-lg bg-red-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-red-600 active:bg-red-700 active:text-red-100/70 active:transition-none"
        (click)="change()">
        Cancel
      </button>
    </div>
  </form>
</div>